import { request } from '../../utils/request';

type User = {
  email: string;
  password: string;
  role_type: 'store_owner';
};

type PhoneUser = {
  phone: string;
  password: string;
  role_type: 'store_owner';
};

export const loginUser = (user: User) => {
  return request({
    method: 'POST',
    url: '/auth/sign-in',
    formData: user,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};

export const loginUserByPhone = (user: PhoneUser) => {
  return request({
    method: 'POST',
    url: '/auth/sign-in/phone',
    formData: user,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
